import React from 'react';
import { useNavigate } from 'react-router-dom';

import { EProduct } from '../../types/misc.enum';

import { useGetEffectiveEntitlementsForUser } from '../../hooks/entitlements';

interface ProductCard {
    title: string;
    description: string;
    locked: boolean;
    img: string;
    btnTxt: string;
    url: string;
};
export const Products = () => {
    const navigate = useNavigate();

    const { data: entitlements } = useGetEffectiveEntitlementsForUser();

    const isProductLocked = (product: EProduct) => {
        if (!entitlements) return true;

        return !entitlements.products.some(p => p.key === product);
    };

    const ProductCards: ProductCard[] = [
        {
            title: "ATLAS - MindShield's Cognitive Security Assessment",
            description: "Explore how your unique mind works when hacker tries to attack, socially engineer or scam you.",
            locked: isProductLocked(EProduct.MCSA),
            img: "product_mcsa.png",
            btnTxt: "Start Assessment",
            url: '/mcsa',
        },
        {
            title: "STAGE - MindShield's Behavioural Training Simulation",
            description: "Train your cognitive security skills through simulations that mimic the real world.",
            locked: isProductLocked(EProduct.MBTS),
            img: "product_mbts.png",
            btnTxt: "Choose Scenario",
            url: '/mbts/scenarios',
        },
    ];

    return (
        <div className='products__page'>
            <p className='text-4xl text-bold color--primary mb-md'>Recommended for you</p>
            <p className='text-lg color--txt-secondary'>Build your cognitive resilience step by step</p>

            <div className="products__cards">
                {ProductCards.map(productCard => (
                    <div
                        key={productCard.title}
                        className='card card--lg card--radius-md products__card'
                    >
                        <div className='products__card__img_sec'>
                            <img src={`/assets/${productCard.img}`} alt="" />
                        </div>
                        <p className='text-2xl text-bold mt-lg'>{productCard.title}</p>
                        <p className='mt-md'>{productCard.description}</p>
                        <div className='mt-xl d-flex justify-content-between align-items-center'>
                            <div className={`products__card__status_pill products__card__status_pill--${productCard.locked ? "locked" : "available"}`}>
                                <p className='text-sm text-medium'>
                                    {productCard.locked ? "Locked" : "Available"}
                                </p>
                            </div>
                            <button
                                className='btn btn--md btn--radius-md btn--primary'
                                disabled={productCard.locked}
                                onClick={() => productCard.locked ? null : navigate(productCard.url)}
                            >
                                {productCard.btnTxt}
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};